var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeepOnlySelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4578_254084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.320007 1.75V6.41667H6.73667V0H2.07001C1.60588 0 1.16076 0.184374 0.83257 0.512563C0.504382 0.840752 0.320007 1.28587 0.320007 1.75H0.320007ZM5.57001 5.25H1.48667V1.75C1.48667 1.59529 1.54813 1.44692 1.65753 1.33752C1.76692 1.22812 1.9153 1.16667 2.07001 1.16667H5.57001V5.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1533 2.91666H8.48666V4.08333H13.1533V2.91666Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1533 10.5H8.48666V11.6667H13.1533V10.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57002 10.5H0.903351V11.6667H5.57002V10.5Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4578_254084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.320007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepOnlySelection);
export default __webpack_public_path__ + "static/media/keep-only-selection.04e5c1365d8c81ed5b7669e01bc2b63a.svg";
export { ForwardRef as ReactComponent };